// extracted by mini-css-extract-plugin
var _1 = "disabledWrapper___SwuCs";
export { _1 as "disabledWrapper" }
